import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/site";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  const next = useCallback(() => setIndex((i) => (i + 1) % total), [total]);
  const prev = () => setIndex((i) => (i - 1 + total) % total);

  useEffect(() => {
    const timer = setInterval(next, 5500);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[440px] md:h-[600px] overflow-hidden bg-foreground-950">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点图`}
            title={`${slide.title} - 51动漫`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-center">
        <div className="max-w-2xl text-background-50">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold mb-4">
            <i className="ri-fire-fill"></i>
            {heroSlides[index].tag}
          </span>
          <h2 className="font-heading font-extrabold text-3xl md:text-5xl leading-tight mb-3">
            {heroSlides[index].title}
          </h2>
          <p className="text-primary-200 text-sm md:text-base font-medium mb-2">
            {heroSlides[index].subtitle}
          </p>
          <p className="text-background-100/85 text-sm md:text-base leading-relaxed mb-6 line-clamp-2 md:line-clamp-3">
            {heroSlides[index].desc}
          </p>
          <div className="flex items-center gap-3">
            <Link
              to={`/anime/detail/${heroSlides[index].animeId}`}
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-fill text-lg"></i>
              查看详情
            </Link>
            <Link
              to="/anime"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-50/50 text-background-50 text-sm font-semibold hover:bg-background-50 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览全部动漫
            </Link>
          </div>
        </div>
      </div>

      {/* Arrows */}
      <button
        type="button"
        aria-label="上一张"
        onClick={prev}
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/25 text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={next}
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/25 text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-primary-500" : "w-2 bg-background-50/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}